import React, { useEffect, useRef } from "react";
import SplitType from "split-type";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const AnimatedText = ({ text, animationType = "fade-up" }) => {
  const textRef = useRef(null);

  useEffect(() => {
    if (window.innerWidth <= 990) return;
const triggerEl =
  textRef.current.closest(".animate-section-trigger") || textRef.current;

    const ctx = gsap.context(() => {
      const split = new SplitType(textRef.current, {
        types: "words, chars",
        tagName: "span",
      });

      const tl = gsap.timeline({
        scrollTrigger: {
    trigger: triggerEl,
          start: "top 60%",
toggleActions: "play none none none"
        },
      });

      if (animationType === "fade-up") {
        tl.from(split.words, {
          y: 16,
          opacity: 0,
          stagger: 0.05,
          duration: 0.55,
          ease: "power2.out(1.7)",
        });
      }

      if (animationType === "rotate") {
        tl.from(split.chars, {
          y: 14,
          opacity: 0,
          stagger: 0.035,
          duration: 0.65,
          ease: "power2.out",
        });
      }

      if (animationType === "scale") {
        tl.from(split.chars, {
          scale: 0.6,
          opacity: 0,
          stagger: 0.05,
          duration: 0.65,
          ease: "back.out(1.4)",
        });
      }

      return () => split.revert();
    }, textRef);

    return () => ctx.revert();
  }, [text, animationType]);

  return <span ref={textRef}>{text}</span>;
};

export default AnimatedText;
